import React, { Component } from "react";
import helpers from "../../helpers";
import ReactCodeInput from "react-code-input";

class Code extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: "",
    };
  }

  codeInput(code) {
    this.setState({
      code: code.toUpperCase(),
    });
    if (code.length === 6) this.printer(code);
  }

  printer(code) {
    return new Promise(async (resolve, reject) => {
      try {
        const qrcode = code.toLowerCase();
        const printerRef = await helpers.getPrinterByQRCode(qrcode);
        if (printerRef) {
          const printer = await helpers.getPrinter(printerRef);
          if (printer) {
            const url = `/?printer=${qrcode}`;
            window.location.href = url;
            setTimeout(() => window.location.reload(), 1000);
          }
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  render() {
    return (
      <div
        id="menu-code"
        className="menu menu-box-bottom"
        data-menu-effect="menu-over"
        data-menu-select="page-components"
        style={{ height: "auto", opacity: 1, display: "block" }}
      >
        <div className="top-20">
          <h2 className="uppercase bold">Printer code</h2>
          <p className="under-heading bottom-20">
            Please type the code appears on the printer
          </p>
          <div className="center-text-huge bottom-0">
            <ReactCodeInput
              type="text"
              value={this.state.code.toUpperCase()}
              autoFocus={false}
              onChange={this.codeInput.bind(this)}
              fields={6}
              inputStyle={{ display: "flex" }}
            />
          </div>
          <a
            href="#"
            className="close-menu button button-s button-center-large button-round-medium shadow-large bg-highlight"
          >
            Close
          </a>
        </div>
      </div>
    );
  }
}

export default Code;



// WEBPACK FOOTER //
// ./src/components/menus/code.js